// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"214":"4df512112dc65d0d","888":"dbda11969f56d410"}[chunkId] + ".css";
};